import { useDispatch, useSelector } from "react-redux";
import {
  getFareclassOptionFilter,
  setFareclassOptionFilter,
} from "@b2bportal/core-flights";
import type { FareclassShelfBrandName } from "@overrides/types";

export const useFlightListGridFilter = () => {
  const fareClasses = useSelector(getFareclassOptionFilter);
  const dispatch = useDispatch();

  const handleFilterFareClasses = (key: FareclassShelfBrandName | "all") => {
    if (key === "all") {
      const newObject = { ...fareClasses };
      Object.keys(newObject).forEach((key) => (newObject[key] = false));
      dispatch(setFareclassOptionFilter(newObject));
      return;
    }

    dispatch(
      setFareclassOptionFilter({ ...fareClasses, [key]: !fareClasses[key] })
    );
  };
  return {
    handleFilterFareClasses,
  };
};
